import * as React from 'react';
import { connect } from 'react-redux';

import NextPreviousButtons from '../NextPreviousButtons';

import {
	ToggleSwitch,
	FormCheckConditional,
	TextInput,
	DropdownInput
} from '../../../../components/forms';

import { PickListType } from '../../../../common/utils';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (e: any) => Promise<any>;
	onQuestionnaireChange: (value?: {}) => void;
	onQuestionnaireNumberKeyUp: (e: any) => void;
	onQuestionnairePaste: (e: any) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
	provinces: any[];
}
const OtherQuestion: React.StatelessComponent<Props> = props => {
	const isNextDisabled = function () {
		let valid = true;
		if (props.questionnaire.isCanadian == null
			|| props.questionnaire.hasBeenCancelled == null
			|| props.questionnaire.pendingCoverage == null
		) {
			valid = false;
		}

		if (props.questionnaire.isCanadian && props.questionnaire.resideProvince == null) {
			valid = false;
		}

		if (props.questionnaire.pendingCoverage &&
			(!props.questionnaire.forcedCoverageAmount
				|| !props.questionnaire.pendingCoverageAmount
				|| props.questionnaire.pendingCoverageReplace == null)) {
			valid = false;
		}
		return !valid;
	};
	return (
		<div>
			<ToggleSwitch
				id="isCanadian"
				labelText={props.questions.isCanadian}
				name="isCanadian"
				onChildren="Yes"
				offChildren="No"
				onBlur={props.onQuestionnaireBlur}
				onChange={props.onQuestionnaireChange}
				checked={props.questionnaire.isCanadian}
				className="toggle-yes-no"
				conditionalChildren={(
					<FormCheckConditional isOpen={props.questionnaire.isCanadian} className="ml-0">
						<DropdownInput
							labelText={props.questions.resideProvince}
							name="resideProvince"
							defaultOption="-"
							options={props.provinces}
							onChange={props.onQuestionnaireChange}
							onBlur={props.onQuestionnaireBlur}
							value={props.questionnaire.resideProvince}
							className="mb-2"
						/>
					</FormCheckConditional>
				)}
			/>
			<ToggleSwitch
				labelText={props.questions.hasBeenCancelled}
				name="hasBeenCancelled"
				onChildren="Yes"
				offChildren="No"
				onBlur={props.onQuestionnaireBlur}
				onChange={props.onQuestionnaireChange}
				checked={props.questionnaire.hasBeenCancelled}
				className="toggle-yes-no"
			/>
			<ToggleSwitch
				labelText={props.questions.pendingCoverage}
				className="mb-2 toggle-yes-no"
				name="pendingCoverage"
				onChildren="Yes"
				offChildren="No"
				onBlur={props.onQuestionnaireBlur}
				onChange={props.onQuestionnaireChange}
				checked={props.questionnaire.pendingCoverage}
				conditionalChildren={
					<FormCheckConditional isOpen={props.questionnaire.pendingCoverage} className="ml-0">
						<TextInput
							labelText={props.questions.forcedCoverageAmount}
							name="forcedCoverageAmount"
							value={props.questionnaire.forcedCoverageAmount}
							onBlur={props.onQuestionnaireBlur}
							onChange={props.onQuestionnaireChange}
							onKeyUp={props.onQuestionnaireNumberKeyUp}
							onPaste={props.onQuestionnairePaste}
							addOnBefore="$"
						/>
						<TextInput
							labelText={props.questions.pendingCoverageAmount}
							name="pendingCoverageAmount"
							value={props.questionnaire.pendingCoverageAmount}
							onBlur={props.onQuestionnaireBlur}
							onChange={props.onQuestionnaireChange}
							onKeyUp={props.onQuestionnaireNumberKeyUp}
							onPaste={props.onQuestionnairePaste}
							addOnBefore="$"
						/>
						<ToggleSwitch
							className="mb-2 toggle-yes-no"
							labelText={props.questions.pendingCoverageReplace}
							name="pendingCoverageReplace"
							onChildren="Yes"
							offChildren="No"
							onBlur={props.onQuestionnaireBlur}
							onChange={props.onQuestionnaireChange}
							checked={props.questionnaire.pendingCoverageReplace}
						/>
					</FormCheckConditional>}
			/>
			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

function mapStateToProps(state: any, ownProps: any) {
	let provinces = state.pickList.items
		.filter((p: PickListItem) => p.pickListTypeId === PickListType.Provinces)
		.map((p: PickListItem) => {
			return { text: p.description!, value: p.description! };
		});
	provinces.sort((a: any, b: any) => {
		if (a.text! < b.text!) {
			return -1;
		}
		if (a.text! > b.text!) {
			return 1;
		}
		return 0;
	});
	provinces.push({ text: 'International', value: 'International' });
	
	return { provinces };
}

export default connect(mapStateToProps)(OtherQuestion);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/basicQuestions/OtherQuestions.tsx